module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/02-01.145e5c7f.mp3";